import React, { FC } from "react"

import MainLayout from "../../common/components/layouts/MainLayout"
import CianSettingsPage from "../../common/components/pages/cian-settings/CianSettingsPage"

const CianSettings: FC = () => {
    return (
        <MainLayout pageTitle="Настройки ЦИАН">
            <div className="page-wrapper">
                <CianSettingsPage />
            </div>
        </MainLayout>
    )
}

export default CianSettings
